import React, { useState, useRef, useEffect } from 'react';
import { Dropdown, Modal } from 'antd';
import { EditOutlined, EyeOutlined } from '@ant-design/icons';
import './index.less';
import useStore from '@/pages/documentCompile/store/useStore';
import { DocumentSettingType } from '@/pages/documentCompile/type';

interface EditModeDropdownProps {
  isEditMode: boolean;
  onChange: (checked: boolean) => void;
  documnetSettingType: DocumentSettingType;
}

const EditModeDropdown: React.FC<EditModeDropdownProps> = ({ isEditMode, onChange, documnetSettingType }) => {
  const [visible, setVisible] = useState(false);
  console.log('documnetSettingType', documnetSettingType);

  // 如果documnetSettingType 是模版，就不需要展示查看按钮，且默认是编辑模式
  const isTemplate = documnetSettingType === DocumentSettingType.DOCUMENT_TEMPLATE;
  let isEditModeNew = isEditMode;
  if (isTemplate) {
    isEditModeNew = true;
  }
  const items = [
    {
      key: 'edit',
      label: (
        <div className="edit-mode-item">
          <span className="menu-item-icon">
            <EditOutlined />
          </span>
          <span className="title">编辑</span>
          {/* <span className="description">进行任何更改</span> */}
        </div>
      ),
    },
    ...(isTemplate ? [] : [
      {
        key: 'view',
        label: (
          <div className="edit-mode-item">
            <span className="menu-item-icon">
              <EyeOutlined />
            </span>
            <span className="title">查看</span>
            {/* <span className="description">查看文件，但不做任何更改</span> */}
          </div>
        ),
      },
    ]),
    // {
    //   key: 'view',
    //   label: (
    //     <div className="edit-mode-item">
    //       <span className="menu-item-icon">
    //         <EyeOutlined />
    //       </span>
    //       <span className="title">查看</span>
    //       {/* <span className="description">查看文件，但不做任何更改</span> */}
    //     </div>
    //   ),
    // },
  ];

  const handleMenuClick = ({ key }: { key: string }) => {
    const deatailEditabled = useStore.getState().deatailEditabled
    if (key === 'edit' && !deatailEditabled) {
      Modal.error({
        title: '当前工程详情处于只读模式，无法进行编辑',
        onOk: () => {
          setVisible(false);
        },
      });
      return
    }
    onChange(key === 'edit');
    setVisible(false);
  };

  return (
    <div className="edit-mode-dropdown" id="edit-mode-dropdown">
      <Dropdown
        menu={{
          items,
          selectedKeys: [isEditModeNew ? 'edit' : 'view'],
          onClick: handleMenuClick,
        }}
        trigger={['click']}
        // getPopupContainer={() => document.getElementById('edit-mode-dropdown') || document.body}
        open={visible}
        onOpenChange={setVisible}
        placement="bottom"
      // align={{
      //   offset: [7, 0], // 向下偏移4px
      // }}
      // arrow={false}
      // destroyPopupOnHide={false} // 不销毁popup，减少重新渲染
      >
        <button className={`btn-header ${isEditModeNew ? 'active' : ''}`}>
          <i className="icon toolbar__icon">
            {isEditModeNew ? <EditOutlined /> : <EyeOutlined />}
          </i>
          <span className="caption">{isEditModeNew ? '编辑' : '查看'}</span>
          <span className="inner-box-caret">
            <i className="caret" />
          </span>
        </button>
      </Dropdown>
    </div>
  );
};

export default EditModeDropdown; 